import React, {Fragment} from "react";
import BasicSelect from "../../../common/BasicSelect";
import useGetOrgMsgDataSourcesBySourceName from "./hooks/useGetOrgMsgDataSourcesBySourceName";

export default function CustomerIoDataSourceSelect({ name, label, placeholder, handleChange, handleFormSelectChange, defaultValue, queryParam, input, meta }) {
    const {msgDataSources} = useGetOrgMsgDataSourcesBySourceName(queryParam);

    return(
        <Fragment>
            <BasicSelect
                name={name}
                label={label}
                placeholder={placeholder}
                defaultValue={defaultValue}
                options={msgDataSources}
                onChange={handleChange}
                handleFormSelectChange={handleFormSelectChange}
                input={input}
                meta={meta} />
        </Fragment>
    )
}